import { Card, CardButtonActionMode, HeaderGradient, MiniCard, Row } from '@app/components';
import React, { memo } from 'react';
import SvgInfo from '@app/components/icons/SvgInfo';
import SvgStats from '@app/components/icons/SvgStats';
import SvgList from '@app/components/icons/SvgList';
import { SlantTitle } from '@app/components/typography';
import { theme } from '@app/theme';
import { useDynamicSizes } from '@app/hooks';
import LinearGradient from 'react-native-linear-gradient';
import { StyleSheet } from 'react-native';
import { IKitchenArea } from '@app/common';
import { UseFormReturn, useWatch } from 'react-hook-form';

type KitchenAreaCardProps = {
  kitchenArea?: Partial<IKitchenArea>;
  formMethods: UseFormReturn<any, any, any>;
  toggle: (mode: CardButtonActionMode) => void;
};

const formatCardData = (partialKitchenArea: Partial<IKitchenArea>) => {
  return {
    name: partialKitchenArea?.name || 'Nouveau lieu de fabrication',
  }
}

export const KitchenAreaCard = memo(({ kitchenArea, formMethods, toggle }: KitchenAreaCardProps) => {
  const { subContainerHeight } = useDynamicSizes();

  const cardData = useWatch({
    control: formMethods.control,
  });

  const {
    name,
  } = formatCardData(cardData);

  return (
    <Card>

      <HeaderGradient>
        <LinearGradient
          start={{ x: 0.5, y: 0 }}
          end={{ x: 0.5, y: 1 }}
          locations={[0, 1]}
          colors={['rgba(253, 255, 252, 0)', 'rgba(253, 255, 252, 1)']}
          style={styles.headerGradient}
        />
      </HeaderGradient>

      <Card.TopHeader>
        <Card.TopHeaderLabel>Fiche lieu de fabrication</Card.TopHeaderLabel>
      </Card.TopHeader>

      <Card.Container height={subContainerHeight}>
        <Card.Background source={require('@app/assets/img/cardbackground.png')} />

        <Card.Content>
          <Card.Header>
            <Row justify="space-between" align="center">
              <Card.HeaderTitles>
                <Card.Title numberOfLines={2}>{name}</Card.Title>
                {kitchenArea?._id && <Card.Subtitle>Ref: {kitchenArea._id}</Card.Subtitle>}
              </Card.HeaderTitles>

              <Card.ButtonAction onPress={toggle} permissionScope="kitchen-areas" />
            </Row>
          </Card.Header>
        </Card.Content>

        <MiniCard>
          <MiniCard.Container>
          </MiniCard.Container>
        </MiniCard>
      </Card.Container>
    </Card>
  );
});

const styles = StyleSheet.create({
  headerGradient: {
    flex: 1,
    height: theme.sizes.listHeaderHeight,
  },
});
